import { jsx as _jsx } from "react/jsx-runtime";
import { BiSolidHome, BiSolidTrash, BiSolidTruck, BiSolidUser, BiSolidWrench } from 'react-icons/bi';
import { twMerge } from 'tailwind-merge';
const EquipmentPill = ({ type, status, className }) => {
    const basePillStyle = twMerge('rounded-full h-[22px] w-full max-w-36 text-center px-2 py-1 text-xs font-bold uppercase leading-[14px] tracking-tight text-[#48484C] transition-colors ease-in-out duration-200', className);
    const iconStyle = 'size-4 text-[#48484C]';
    switch (type) {
        case 'CONTAINER':
            switch (status) {
                case 'ACTIVE':
                    return _jsx("div", { className: twMerge(basePillStyle, 'border border-[#9DCA9A] bg-[#E0EBDF]'), children: "Active" });
                case 'DECOMMISSIONED':
                    return _jsx("div", { className: twMerge(basePillStyle, 'border border-[#F07D7D] bg-[#FADADA]'), children: "Decommissioned" });
                case 'OUT_OF_SERVICE':
                    return _jsx("div", { className: twMerge(basePillStyle, 'border border-[#FFD345] bg-[#FFF2CC]'), children: "Out of Service" });
                default:
                    return _jsx("div", { className: twMerge(basePillStyle, 'bg-gray-200'), children: status });
            }
        case 'HISTORY':
            switch (status) {
                case 'YARD':
                    return _jsx(BiSolidHome, { className: iconStyle });
                case 'CUSTOMER':
                    return _jsx(BiSolidUser, { className: iconStyle });
                case 'DISPOSAL_FACILITY':
                    return _jsx(BiSolidTrash, { className: iconStyle });
                case 'MAINTENANCE_OR_REPAIR':
                    return _jsx(BiSolidWrench, { className: iconStyle });
                case 'TRANSIT':
                    return _jsx(BiSolidTruck, { className: iconStyle });
                default:
                    return _jsx("div", { className: twMerge(basePillStyle, 'bg-gray-200'), children: status });
            }
        default:
            return _jsx("div", { className: `${basePillStyle} bg-gray-200`, children: "Unknown" });
    }
};
export default EquipmentPill;
//# sourceMappingURL=equipment-pill.js.map